/* Greens & Flowers thema: zoeken, klantenservice-menu, favorieten, cookiebalk */
(() => {
  'use strict';
  const GF = window.GF || {};
  const I = GF.i18n || {};
  const U = GF.util || {};
  const $ = U.$ || ((s, r = document) => r.querySelector(s));
  const $$ = U.$$ || ((s, r = document) => [...r.querySelectorAll(s)]);
  const money = U.money;
  const esc = U.esc;
  const json = U.json;
  const lock = (on) => GF.lockScroll && GF.lockScroll(on);

  /* ---- Zoeken ---- */
  const searchEl = $('#search'), input = $('#searchInput'), out = $('#searchOut');
  function setSearch(open) {
    if (!searchEl) return;
    searchEl.hidden = !open;
    lock(open);
    if (open) { input.focus(); input.select(); }
  }
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-search-open]');
    if (s) { e.preventDefault(); if (GF.closeMenu) GF.closeMenu(); setSearch(true); }
    if (e.target.closest('[data-search-close]')) setSearch(false);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && searchEl && !searchEl.hidden) setSearch(false); });
  searchEl && searchEl.addEventListener('click', (e) => { if (e.target === searchEl) setSearch(false); });
  let timer = 0, seq = 0;
  input && input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { out.innerHTML = ''; return; }
    timer = setTimeout(async () => {
      const my = ++seq;
      try {
        const r = await fetch(`${GF.routes.suggest}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`).then((x) => x.json());
        if (my !== seq) return;
        const list = r.resources.results.products || [];
        out.innerHTML = list.length
          ? `<p class="s-label">${I.plants}</p>${list.map((p) => `<a class="s-hit" href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}<span>${esc(p.title)}<small>${esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '')}</small></span></a>`).join('')}<p class="s-all"><a class="linkish" href="${GF.routes.search}?type=product&q=${encodeURIComponent(q)}">${(I.allFor || '').replace('__TERMS__', esc(q))}</a></p>`
          : `<p class="s-label">${I.none}</p>`;
      } catch (e) { out.innerHTML = ''; }
    }, 220);
  });

  /* ---- Klantenservice-menu ---- */
  const svc = $('.bn-service');
  if (svc) {
    const tr = $('.bn-trigger', svc);
    tr.addEventListener('click', () => { const o = svc.classList.toggle('is-open'); tr.setAttribute('aria-expanded', String(o)); });
    document.addEventListener('click', (e) => { if (!svc.contains(e.target)) { svc.classList.remove('is-open'); tr.setAttribute('aria-expanded', 'false'); } });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { svc.classList.remove('is-open'); tr.setAttribute('aria-expanded', 'false'); } });
  }

  /* ---- Favorieten ---- */
  const KEY = 'gf-favorites';
  const getFavs = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const setFavs = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) { /* geen opslag */ } };
  const syncFavs = () => { const f = getFavs(); $$('[data-fav-count]').forEach((c) => { c.textContent = f.length; c.hidden = !f.length; }); $$('[data-fav]').forEach((b) => b.setAttribute('aria-pressed', String(f.includes(b.dataset.fav)))); };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-fav]');
    if (!b) return;
    e.preventDefault();
    let f = getFavs();
    f = f.includes(b.dataset.fav) ? f.filter((x) => x !== b.dataset.fav) : [...f, b.dataset.fav];
    setFavs(f); syncFavs();
  });
  syncFavs();
  const favGrid = $('#favGrid');
  if (favGrid) {
    const f = getFavs();
    if (f.length) {
      favGrid.innerHTML = '';
      f.forEach(async (h) => {
        try {
          const p = await json(`${GF.root || '/'}products/${h}.js`);
          const img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_640x$1$2') : '';
          favGrid.insertAdjacentHTML('beforeend', `<li class="p-item"><div class="p-media"><a class="p-link" href="${esc(p.url)}"><figure class="p-img tone-sage">${img ? `<img class="p-photo" src="${esc(img)}" alt="${esc(p.title)}" loading="lazy">` : ''}</figure></a><button class="p-fav" type="button" data-fav="${esc(h)}" aria-pressed="true" aria-label="${esc(I.removeFav)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.3A4.2 4.2 0 0 1 12 7.8a4.2 4.2 0 0 1 7.5 2.4c0 5.7-7.5 10.3-7.5 10.3Z"/></svg></button></div><a class="p-link p-text" href="${esc(p.url)}"><h3 class="p-name">${esc(p.title)}</h3><p class="p-price">${money(p.price)}</p></a></li>`);
        } catch (e) { /* product bestaat niet meer */ }
      });
    }
  }

  /* ---- Cookiebalk ---- */
  const consent = $('#consent');
  try { if (consent && !localStorage.getItem('gf-consent')) consent.hidden = false; } catch (e) { /* */ }
  document.addEventListener('click', (e) => { if (e.target.closest('[data-consent]')) { try { localStorage.setItem('gf-consent', '1'); } catch (x) { /* */ } consent.hidden = true; } });
})();